import React from "react";
import { Item } from "./Yuyue";
import styles from "../css/Yuyue.css";
import { Header } from "./Introduce";
import { Toast } from "antd-mobile";
import { request } from "../request";
import { showAlert2, Button, checkToekn } from "../tools/wechatBrower";
import selfStyle from "../css/SampleDelivery.css";
import { Link } from "react-router-dom";



export const Status = ({ left, value, style }) => {
    let _color;
    let _value;
    switch (value) {
        case "status7":
            _value = "测试费用已确认请及时缴费";
            _color = "aquamarine";

            break;
        case "status6":
            _value = "费用已结算";
            _color = selfStyle.statusStyle1;

            break;
        case "status5":
            _value = "结果已上传";
            _color = "blue";

            break;
        case "status4":
            _value = "样品已收到";
            _color = "brown";

            break;
        case "status3":
            _value = "负责人已确认";
            _color = "green";

            break;
        case "status2":
            _value = "需补充信息";
            _color = "red";

            break;
        case "status1":
            _value = "需求已提交";
            _color = "#ae5cc9";
            break;

        case "status0":
            _value = "需求未提交";
            _color = "";
            break;

        default:
            _value = "";

            _color = "";
            break;
    }

    return (
        <div className={styles.item} style={style}>
            <span className={styles.itemLeft}>{left}</span>
            <input
                style={{ color: _color }}
                className={selfStyle.status}
                value={_value}
                disabled={value ? true : false}
            />
        </div>
    );
};

const ShowZero = () => {
    return (
        <div
            style={{
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                paddingTop: "3rem",
            }}
        >
            <img
                src={require("../static/无结果状态.png")}
                className={selfStyle.img}
                alt=""
            />

            <p className={selfStyle.text}>
                没有查询到您的服务单，
                <Link to="yuyue">
                    <span className={selfStyle.sj}>我要送检</span>
                </Link>
            </p>
        </div>
    );
};

export default class extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: {
                list: [],
            },
        };
    }

    async componentDidMount() {
        let res = await checkToekn();

        if (res) {
            this.init();
        }
    }

    init() {
        request(
            "index/getOrder",
            { uid: localStorage.getItem("openid") },
            ({ data }) => {
                if (data.code === 1) {
                    this.state.data.list = data.data;
                    this.setState();
                } else {
                    Toast.fail("获取订单失败");
                }
            },
            (err) => {
                console.error("err", err);
                Toast.fail("获取订单失败");
            }
        );
    }

    enclosure(element, index) {
        if (element.status === "status0") {
            return (
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        borderTop: "solid 1px #dddd",
                        marginTop: "5px"
                    }}
                >
                    <Button
                        style={{
                            width: "5rem",
                            height: "1.3rem",
                            fontSize: "0.7rem",
                            lineHeight: "1rem",
                            marginTop: "0.4rem",
                            backgroundColor: "green",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center"
                        }}
                        onClick={() => {
                            this.props.history.push("/Cache/" + element.id);
                        }}
                        title="修改"
                    />

                    <Button
                        style={{
                            width: "5rem",
                            height: "1.3rem",
                            fontSize: "0.7rem",
                            lineHeight: "1rem",
                            marginTop: "0.4rem",
                            backgroundColor: "red",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center"
                        }}
                        onClick={() => {
                            showAlert2({
                                content: "删除后不可以修复，请问确认删除吗？",
                                cancelFunc: () => {
                                },
                                enterFunc: () => {
                                    let that = this;
                                    that.state.data.list.splice(index, 1);
                                    that.setState();
                                    request(
                                        "index/deleteOrder",
                                        {
                                            uid: localStorage.getItem("openid"),
                                            id: element.id,
                                        },
                                        ({ data }) => {

                                            if (data.code === 0) {
                                                Toast.fail("删除失败");
                                            }

                                        }
                                    );
                                },
                            });
                        }}
                        title={"删除"}
                    />
                </div>
            );
        }
        // 状态等于 结果已上传 并且 未填写过补充信息
        else if (element.status === "status5" && element.is_info != 1) {
            // 补充信息 只有在结果上传之后的两个周之内显示
            if ((Date.now() - element.status5_createtime * 1000) / 1000 > 24 * 3600 * 14) {
                return (
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderTop: "solid 1px #dddd",
                            marginTop: "5px"
                        }}
                    >
                        <Button
                            style={{
                                width: "5rem",
                                height: "1.3rem",
                                fontSize: "0.7rem",
                                lineHeight: "1rem",
                                marginTop: "0.4rem",
                                backgroundColor: "#ed5a5a",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center"
                            }}
                            onClick={() => {
                                this.props.history.push("/AgainOrder/" + element.id);
                            }}
                            title={"再次下单"}
                        />


                        <Button
                            style={{
                                width: "5rem",
                                height: "1.3rem",
                                fontSize: "0.7rem",
                                lineHeight: "1rem",
                                marginTop: "0.4rem",
                                backgroundColor: "#ae5cc9",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center"
                            }}
                            onClick={() => {
                                this.props.history.push("/sampleDelivery/" + element.id);
                            }}
                            title={"查看"}
                        />
                    </div>
                );
            } else {
                return (
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderTop: "solid 1px #dddd",
                            marginTop: "5px"
                        }}
                    >
                        <Button
                            style={{
                                width: "5rem",
                                height: "1.3rem",
                                fontSize: "0.7rem",
                                lineHeight: "1rem",
                                marginTop: "0.4rem",
                                backgroundColor: "#ed5a5a",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center"
                            }}
                            onClick={() => {
                                this.props.history.push("/AgainOrder/" + element.id);
                            }}
                            title={"再次下单"}
                        />

                        <Button
                            style={{
                                width: "5rem",
                                height: "1.3rem",
                                fontSize: "0.7rem",
                                lineHeight: "1rem",
                                marginTop: "0.4rem",
                                backgroundColor: "#18bc9c",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center"
                            }}
                            onClick={() => {
                                this.props.history.push("/seeOrderV2/" + element.id);
                            }}
                            title={"补充信息"}
                        />

                        <Button
                            style={{
                                width: "5rem",
                                height: "1.3rem",
                                fontSize: "0.7rem",
                                lineHeight: "1rem",
                                marginTop: "0.4rem",
                                backgroundColor: "#ae5cc9",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center"
                            }}
                            onClick={() => {
                                this.props.history.push("/sampleDelivery/" + element.id);
                            }}
                            title={"查看"}
                        />
                    </div>
                );
            }

        }

        else {
            return (
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        borderTop: "solid 1px #dddd",
                        marginTop: "5px"
                    }}
                >
                    <Button
                        style={{
                            width: "5rem",
                            height: "1.3rem",
                            fontSize: "0.7rem",
                            lineHeight: "1rem",
                            marginTop: "0.4rem",
                            backgroundColor: "#ed5a5a",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center"
                        }}
                        onClick={() => {
                            this.props.history.push("/AgainOrder/" + element.id);
                        }}
                        title={"再次下单"}
                    />

                    <Button
                        style={{
                            width: "5rem",
                            height: "1.3rem",
                            fontSize: "0.7rem",
                            lineHeight: "1rem",
                            marginTop: "0.4rem",
                            backgroundColor: "#ae5cc9",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center"
                        }}
                        onClick={() => {
                            this.props.history.push("/sampleDelivery/" + element.id);
                        }}
                        title={"查看"}
                    />
                </div>
            );
        }
    }

    main() {
        console.log("this.state.data.list", this.state.data.list);
        if (this.state.data.list.length > 0) {
            return (
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        flexDirection: "column",
                        paddingBottom: "15px",
                    }}
                >
                    {this.state.data.list.map((element, index) => (
                        <div
                            className={styles.info}
                            style={{ padding: "5px 5%" }}
                        // onClick={() => {
                        //   console.log("卧槽");
                        //   element.status === "status0"
                        //     ? this.props.history.push("/Cache/" + element.id)
                        //     : this.props.history.push("/sampleDelivery/" + element.id);
                        // }}
                        >
                            <Item
                                left="个人姓名"
                                value={element.name}
                                disabled={true}
                                style={{ lineHeight: '1.2rem' }}
                            />


                            {/* <Item  原来 状态已夺回 会在7天后自动删除
                                left="服务单号"
                                value={
                                    element.status === "status0" || element.status === "status2"
                                        ? element.id_text
                                        : element.id
                                }
                                disabled={true}
                                style={{ lineHeight: '1.2rem' }}
                            /> */}
                            <Item
                                left="服务单号"
                                value={
                                    element.id
                                }
                                disabled={true}
                                style={{ lineHeight: '1.2rem' }}
                            />
                            <Item
                                left="提交时间"
                                value={element.createtime}
                                disabled={true}
                                style={{ lineHeight: '1.2rem' }}
                            />
                            <Status
                                left="服务状态"
                                value={element.status}
                                disabled={true}
                                style={{ lineHeight: '1.2rem' }}
                            />
                            {this.enclosure(element, index)}
                        </div>
                    ))}
                </div>
            );
        } else {
            return <ShowZero />;
        }
    }

    render() {
        return (
            <div>
                <Header text="我的服务单" />
                {this.main()}
                <div style={{ height: "80px", width: "100%" }} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/pages/NOrderList.js